import { render, staticRenderFns } from "./imageBlockBg.vue?vue&type=template&id=9164df72&"
import script from "./imageBlockBg.vue?vue&type=script&lang=js&"
export * from "./imageBlockBg.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports